<div class="copy_ticket_popup_wrapper">
  <div class="dialog-header">
    <div class="header-icon">
      <mat-icon>content_copy</mat-icon>
    </div>
    <h2>Copy Ticket</h2>
    <button class="close-btn" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content" [formGroup]="sectionForm">
    <p>Create a copy of ticket: <b>{{ data.ticketTitle }}</b></p>

    <div class="form-group">
      <label for="copyTicketTitle" class="price-label">Title *</label>
      <div class="input-box">
        <input
          id="copyTicketTitle"
          type="text"
          formControlName="title"
          class="form-control"
          placeholder="Enter copied ticket title"
          />
      </div>
      <app-validation-error
        [formGroup]="sectionForm"
        [controlName]="'title'"
      ></app-validation-error>
    </div>

    <div class="form-group">
      <label class="price-label">Select Module *</label>
      <ng-select
        [items]="modules"
        bindLabel="name"
        placeholder="Select module"
        formControlName="module"
        [searchable]="true"
        [loading]="isModulesLoading"
        (change)="onModuleChange()"
        >
      </ng-select>
      <app-validation-error
        [formGroup]="sectionForm"
        [controlName]="'module'"
      ></app-validation-error>
    </div>

    <div class="form-group">
      <label class="price-label">Reference Number *</label>
      <ng-select
        [items]="referenceSearchOptions"
        bindLabel="name"
        bindValue="id"
        [typeahead]="referenceSearchInput$"
        [loading]="referenceSearchLoading"
        [searchable]="true"
        [clearable]="true"
        [disabled]="!sectionForm.get('module')?.value || isModulesLoading"
        placeholder="Search by name or reference ID..."
        formControlName="reference_id"
        >
      </ng-select>
      <app-validation-error
        [formGroup]="sectionForm"
        [controlName]="'reference_id'"
      ></app-validation-error>
    </div>
  </div>

  <div class="dialog-footer">
    <button class="btn-cancel" (click)="close()">
      <mat-icon>close</mat-icon>
      <span>Cancel</span>
    </button>
    <button class="btn-submit" (click)="onCopy()" [disabled]="isLoading || isModulesLoading">
      @if (!isLoading) {
        <mat-icon>check_circle</mat-icon>
      }
      @if (isLoading) {
        <mat-spinner diameter="16"></mat-spinner>
      }
      <span>{{ isLoading ? 'Copying...' : 'Copy' }}</span>
    </button>
  </div>
</div>
